import { render, staticRenderFns } from "./other_data_statistics.vue?vue&type=template&id=d50de986&scoped=true"
import script from "./other_data_statistics.vue?vue&type=script&lang=js"
export * from "./other_data_statistics.vue?vue&type=script&lang=js"
import style0 from "./other_data_statistics.vue?vue&type=style&index=0&id=d50de986&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50de986",
  null
  
)

export default component.exports